import { CurrencyEnum } from '../enums';

export const currencySymbols = {
  [CurrencyEnum.AMD]: '&#1423;',
  [CurrencyEnum.USD]: '&#36;',
  [CurrencyEnum.EUR]: '&#x20AC;',
  [CurrencyEnum.RUR]: '&#8381;',
} as const;
